// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"492dd4ffacd0309b2fd9","478":"1b59c689891afdedfa21","869":"f3603bdaf78e4dd6900e","980":"cba2a3d75fdbe3fddad6"}[chunkId] + ".js";
};